import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  CUSTOM_CODE_DIALOG_CONFIG,
  CustomCodeDialogData,
  CustomCodeDialogResult,
  SmartCartFormCustomCodeDialogComponent,
} from '../../../custom-code/custom-code-dialog.component';
import { GOALS_PROGRESS_BAR_STARTER_TEMPLATE, GOALS_PROGRESS_BAR_VARIABLES } from '../../goals-progress-bar.model';

@Component({
  selector: 'smart-cart-goals-custom-code-card',
  templateUrl: './custom-code-card.component.html',
  styleUrls: ['../../../../components/shared.scss'],
  standalone: false,
})
export class SmartCartGoalsCustomCodeCardComponent {
  @Input({ required: true }) enabledControl!: FormControl<boolean>;
  @Input({ required: true }) codeControl!: FormControl<string>;

  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);

  // ponytail: one in-memory previous version, lost on page reload. Persisting it would mean adding a
  // field to the saved widget config, which is out of scope on PDQ-8071.
  private previousSavedCode = '';

  onEditCode(): void {
    this.dialog
      .open<SmartCartFormCustomCodeDialogComponent, CustomCodeDialogData, CustomCodeDialogResult | null>(
        SmartCartFormCustomCodeDialogComponent,
        {
          ...CUSTOM_CODE_DIALOG_CONFIG,
          data: {
            code: this.codeControl.value,
            defaultCode: GOALS_PROGRESS_BAR_STARTER_TEMPLATE,
            previousCode: this.previousSavedCode,
            variables: GOALS_PROGRESS_BAR_VARIABLES,
          },
        },
      )
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (!result) return;
        if (result.code === this.codeControl.value) return;
        this.previousSavedCode = this.codeControl.value;
        this.codeControl.setValue(result.code);
      });
  }
}
